import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource, Query } from 'utility-ts-orm';
import { MajorCredential } from '../builders/major_credential_builder';
import { MajorProgram } from './../builders/major_programs_builder';
import { IMajorActivitySubject, MajorProgramModel } from './../models/major_program_model';
import { MajorBuilderServant } from './../servants/major_builder_servant';

export class MajorCurrentMajorsQuery implements IQuery {
  private __result: MajorProgram[];

  constructor(
    private ngMajorCurrentMajorsDatastore: IDatasource<MajorProgram>,
    private numberFormatterFn: any,
    private ngMajorProgramModel: MajorProgramModel,
    private ngMajorBuilderServant: MajorBuilderServant
  ) {
    Query.registerQuery(this, this.ngMajorCurrentMajorsDatastore);
  }

  run(): this {
    this.__result = _4.map(this.ngMajorCurrentMajorsDatastore.values(), (program: MajorProgram) =>
      this.ngMajorBuilderServant.buildMajor(program)
    );
    this.calculateTuition(this.result);
    this.assignSubjectsActivities(this.result);
    return this;
  }

  get result() {
    return this.__result;
  }

  calculateTuition(programs: MajorProgram[]) {
    _4.forEach(programs, (program: MajorProgram) => {
      program._in_state_tuition = this.numberFormatterFn.convertToDollars(
        program.credits * this.ngMajorProgramModel.in_state_credit_cost
      );
    });
  }

  assignSubjectsActivities(programs: MajorProgram[]) {
    _4.forEach(programs, (program: MajorProgram) => {
      _4.forEach(program.student_program_activity, (majoractivity: IMajorActivitySubject) => {
        program._interests.push(
          _4.find(this.ngMajorProgramModel.activity, {
            id: majoractivity
          })
        );
      });

      _4.forEach(program.student_program_subject, (majorsubject: IMajorActivitySubject) => {
        program._interests.push(
          _4.find(this.ngMajorProgramModel.subject, {
            id: majorsubject
          })
        );
      });

      program._has_interests = !_4.isEmpty(_4.compact(program._interests));
    });
  }
}

angular.module('major-explorer-data').service('ngMajorCurrentMajorsQuery', MajorCurrentMajorsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/queries/major_current_majors_query.ts